
export default function usePlatform() {
    function isIOS() {
        let flag = navigator.userAgent.match(/(iPhone|iPad|iPod|iOS)/i);
        return flag;
    }

    function isAndroid() {
        let flag = navigator.userAgent.match(/(Android)/i);
        return flag;
    }

    return {
        isIOS, isAndroid
    }
}
